var _defs, _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDentist(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36.512,
    height: 37.073,
    viewBox: "0 0 36.512 37.073",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "dentist") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#7a7b7d;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M-5405.885,507.591a7.038,7.038,0,0,0-6.8,7.033V520a.636.636,0,0,0,.187.453.64.64,0,0,0,.454.187h13.682v-8.251c-.12-.01-.237-.025-.355-.045h0a8.269,8.269,0,0,1-6.164-4.739q-.152,0-.3-.012c-.235-.015-.469-.019-.7-.011Zm-2.183,8.821h4.837v.853h-4.837Z",
    transform: "translate(5412.682 -485.511)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M-5403.227,500.65a10.078,10.078,0,0,0-6.2,1.918,1.708,1.708,0,0,0-.7,1.38v4.34h13.239v-4.34a1.7,1.7,0,0,0-.7-1.379,10.076,10.076,0,0,0-5.635-1.918Zm-.711,1.7h.858v1.593h1.589v.853h-1.589v1.592h-.858v-1.592h-1.589v-.853h1.589Z",
    transform: "translate(5418.256 -500.646)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M-5397.9,898.94a1.956,1.956,0,0,1,.137,1.787,10.566,10.566,0,0,0,0,8.242h-10.223v-8.25c.117-.011.234-.026.353-.045a8.27,8.27,0,0,0,6.161-4.738c.1,0,.205,0,.308-.009a7.049,7.049,0,0,1,2.336.237,6.327,6.327,0,0,0,.92,2.775Z",
    transform: "translate(5422.937 -873.816)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M-5403.121,894.926a5.469,5.469,0,0,0-.9,6.866,2.8,2.8,0,0,1,.2,2.569,9.715,9.715,0,0,0,1.305,9.772.148.148,0,0,0,.182.043.149.149,0,0,0,.077-.168,8.961,8.961,0,0,1,1.4-7.273,2.209,2.209,0,0,1,1.8-.933,2.209,2.209,0,0,1,1.8.933,8.961,8.961,0,0,1,1.4,7.273.147.147,0,0,0,.078.164.148.148,0,0,0,.178-.039,9.715,9.715,0,0,0,1.307-9.773,2.806,2.806,0,0,1,.2-2.568,5.469,5.469,0,0,0-.906-6.865,1.956,1.956,0,0,0-2.416-.2,3.759,3.759,0,0,0-.524.421,1.618,1.618,0,0,1-2.238,0,3.724,3.724,0,0,0-.525-.419,1.954,1.954,0,0,0-2.413.2Z",
    transform: "translate(5429.787 -877.117)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M-5403.328,901.282a3.841,3.841,0,0,1-1.272,0,7.415,7.415,0,0,1-5.417-4.024,3.665,3.665,0,0,0,2.38-2.012,7.655,7.655,0,0,0,7.35,0,3.666,3.666,0,0,0,2.38,2.012A7.419,7.419,0,0,1-5403.328,901.282Z",
    transform: "translate(5418.496 -875.266)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M-5396.647,897.326a19.856,19.856,0,0,0-.042-5.683h-13.369a19.718,19.718,0,0,0-.043,5.683,6.793,6.793,0,0,0,6.729,5.864,6.791,6.791,0,0,0,6.728-5.865Z",
    transform: "translate(5417.908 -883.13)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDentist);
export default __webpack_public_path__ + "static/media/dentist.6d97171018b22787b3f332e6a82ec114.svg";
export { ForwardRef as ReactComponent };